"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppraisalSystemRolePermissionMap = exports.RolePermissions = exports.DirectorPermissions = exports.AppraiserPermissions = exports.AppraisalPermissions = exports.EmployeePermissions = void 0;
var Role_1 = require("./Role");
var EmployeePermissions;
(function (EmployeePermissions) {
    EmployeePermissions["List"] = "Employees.List";
    EmployeePermissions["Manage"] = "Employees.Manage";
})(EmployeePermissions = exports.EmployeePermissions || (exports.EmployeePermissions = {}));
var AppraisalPermissions;
(function (AppraisalPermissions) {
    AppraisalPermissions["List"] = "Appraisals.List";
    AppraisalPermissions["Manage"] = "Appraisals.Manage";
    AppraisalPermissions["ReviewAll"] = "Appraisals.ReviewAll";
})(AppraisalPermissions = exports.AppraisalPermissions || (exports.AppraisalPermissions = {}));
var AppraiserPermissions;
(function (AppraiserPermissions) {
    AppraiserPermissions["List"] = "Appraiser.List";
    AppraiserPermissions["Manage"] = "Appraiser.Manage";
})(AppraiserPermissions = exports.AppraiserPermissions || (exports.AppraiserPermissions = {}));
var DirectorPermissions;
(function (DirectorPermissions) {
    DirectorPermissions["List"] = "Directors.List";
    DirectorPermissions["Manage"] = "Directors.Manage";
})(DirectorPermissions = exports.DirectorPermissions || (exports.DirectorPermissions = {}));
var RolePermissions;
(function (RolePermissions) {
    RolePermissions["Manage"] = "Roles.Manage";
})(RolePermissions = exports.RolePermissions || (exports.RolePermissions = {}));
/**
 * This object is where the mapping of permissions to roles takes place.
 * When adding a new module, where new permissions are being created, add it
 * here to grant the permissions to the role.
 */
exports.AppraisalSystemRolePermissionMap = (_a = {},
    _a[Role_1.Role.HrManager] = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], Object.values(EmployeePermissions)), Object.values(AppraisalPermissions)), Object.values(AppraiserPermissions)), Object.values(RolePermissions)),
    _a[Role_1.Role.Director] = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], Object.values(EmployeePermissions)), Object.values(AppraisalPermissions)), Object.values(AppraiserPermissions)), Object.values(RolePermissions)), Object.values(DirectorPermissions)),
    _a[Role_1.Role.Appraiser] = __spreadArray([
        EmployeePermissions.List,
        AppraisalPermissions.List,
        AppraisalPermissions.Manage
    ], Object.values(AppraiserPermissions)),
    _a);
//# sourceMappingURL=AppraisalSystemRolePermissionMap.js.map